import React from 'react';

const Button = ( {children, className, style, onClick} ) => {

  const handleClick = () => {
    onClick();
  }

  return (
    <button className={`button ${className}`} onClick={ handleClick } style={ style }>
      { children }
    </button>
  );
}

Button.defaultProps = {
  onClick: () => {}
}


export default Button;
